export default __webpack_public_path__ + "static/media/hand-left-front.9f9b8dc8.png";